import apiFetch from '../apiFetch'

export default function (token, documentVisualization) {
  return apiFetch({ endPoint: `DocumentVisualization/${documentVisualization.documentVisualizationId}`, method: 'PUT', body: documentVisualization, token: token })
}
